import BaseModel from '../core/BaseModel';
export default class JoinModel extends BaseModel {
    constructor() {
        super({ 
                name: "join",
                tableName: 'clubs_member', 
                label: "Joined club", 
                display_key: 'id', 
                default_order: { key: 'created_at', direction: 'asc' } ,
            },  
            {
            stt: { 
                name: "stt", 
                label: "No.", 
                width : 5,
                class: 'center',
                computed: (data, index) => {
                    data.stt = index + 1;
                }
            },
            id: { 
                name: 'id', 
                type: "Int", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            uid: {
                name: 'uid',
                display: false
            },
            users: {
                refs: "users {fullname email clubs_member{id}}",
                display: false
            },
            clubs: {
                refs: `clubs {id club_name skill{id skill_lang(where: {lang: {_eq: "en"}}){name}} club_operating_time { operating_time { operating_time_lang (where: {lang: {_eq: "en"}}) {name}}} country{country_lang(where: {lang: {_eq: "en"}}) {name}} province{province_lang(where: {lang: {_eq: "en"}}) {name}} district{district_lang(where: {lang: {_eq: "en"}}) {name}} clubs_member(where: {role: {_eq: "owner"}}){uid role users{fullname}} }`,
                display: false
            },
            club_name: {
                name: 'club_name',
                type: "String", 
                label: 'Club name',
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
                computed: (data) => {
                    data.club_name = '';
                }
            },
            owner_name: {
                name: 'owner_name',
                type: "String", 
                label: 'Owner name',
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
                computed: (data) => {
                    data.owner_name = '';
                }
            },
            address: {
                name: 'address',
                type: "String",
                label: 'Main active area', 
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
                computed: (data) => {
                    data.address = "";
                },
                width: 15
            },
            skill_id: {
                name: 'skill_id', 
                label: 'Club skill', 
                type: "String",
                computed: (data) => {
                    data.skill_id = null
                }
            },
            clubs_member: {
                name: 'clubs_member',
                type: "CustomUrl",
                class: "center",
                label: 'Member',
                computed: (data) => {
                    data.clubs_member = 0;
                }
            },
            join_date: {
                name: 'join_date', 
                type: "Datetime", 
                label: 'Member since',
                filter: { type: 'DateRange', match: 'contains'},
            },
            role: {
                name: 'role', 
                type: "Selection", 
                label: 'Role',
                options: [{
                    value: 'member',
                    label: 'Member'
                },
                {
                    value: 'admin',
                    label: 'Admin'
                },
                {
                    value: 'owner',
                    label: 'Owner'
                }
                ],
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            status: {
                name: 'status', 
                type: "Selection", 
                label: 'Status',
                options:[{
                    value: 'waiting',
                    label: 'Waiting for approve',
                },{
                    value: 'approved',
                    label: 'Approved'
                },{
                    value: 'rejected',
                    label: 'Rejected'
                },{
                    value: 'leaved',
                    label: 'Leaved'
                }],
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            }
        },)
    }

}